import fleetlogicAPI from "helpers/fleetlogicAPI";

export const AuthorizationToken = {
  set(token: string) {
    fleetlogicAPI.defaults.headers.common.Authorization = `JWT ${token}`;
    fleetlogicAPI.defaults.headers.common.version = process.env.VERSION;
  },
  delete() {
    delete fleetlogicAPI.defaults.headers.common.Authorization;
  }
};

AuthorizationToken.set(localStorage.jwtToken);
